/**
 * GDPR-compliant cookie consent helpers for U&Fashion.
 *
 * We only load the Meta (Facebook) Pixel — a marketing cookie — after
 * the visitor has explicitly accepted. Essential cookies (session,
 * language) never require consent.
 *
 * State is stored in localStorage under `uf_cookie_consent` and can be
 * one of: 'accepted' | 'rejected' | undefined (banner not answered yet).
 */

const STORAGE_KEY = 'uf_cookie_consent';
const META_PIXEL_ID = '509574832803811';

export const CONSENT_ACCEPTED = 'accepted';
export const CONSENT_REJECTED = 'rejected';

export const getConsent = () => {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    /* ignore */
  }
};

export const hasAccepted = () => getConsent() === CONSENT_ACCEPTED;

/**
 * Dynamically inject the Meta Pixel loader + fire init + first PageView.
 * Guarded so it can safely be called multiple times (e.g. on route
 * change or when consent flips).
 */
export const loadMetaPixel = () => {
  if (typeof window === 'undefined') return;
  if (window.__ufMetaPixelLoaded) {
    // already loaded — just make sure the init/PageView have fired.
    if (typeof window.fbq === 'function') {
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
    }
    return;
  }
  window.__ufMetaPixelLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  script.onload = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('init', META_PIXEL_ID);
      window.fbq('track', 'PageView');
    }
  };
};
